import { useState } from 'react';
import { Modal, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

export const ReactivateRider = ({ rider, reactivateRider }: { rider: RiderDetails; reactivateRider: () => void }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleReactivateRider = async () => {
    await reactivateRider();
    setModalOpen(false);
  };

  const Presentation = () => {
    return (
      <Modal open={modalOpen} maxWidth="sm" onClose={() => setModalOpen(false)} data-testid="reactivate-rider-modal">
        <Modal.Title>Reactivate Rider</Modal.Title>
        <Modal.Content>
          <Text textColor="secondaryText" fontWeight={300}>
            {` Rider ${rider.firstName} ${rider.lastName} will be added to the active ride list, and can be added to other rides.`}
          </Text>
          <Text textColor="secondaryText" fontWeight={300}>
            {'Please double check the rider info to make sure it’s up to date.'}
          </Text>
        </Modal.Content>
        <Modal.Actions>
          <Button color="tertiary" onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button autoFocus color="primary" onClick={handleReactivateRider}>
            Reactivate
          </Button>
        </Modal.Actions>
      </Modal>
    );
  };

  return rider.state === 'deactivated' ? (
    <>
      <Button color="primary" size="large" onClick={() => setModalOpen(true)}>
        Reactivate
      </Button>
      <Presentation />
    </>
  ) : null;
};
